export function findBestActiveDescendantId(data) {
    const nodes = new Map();
    data.filter(({ active }) => active).forEach(({ descendantId, ancestorId, coefficient }) => {
        if (!nodes.has(descendantId)) {
            nodes.set(descendantId, {
                id: descendantId,
                coeff: coefficient,
                parent: ancestorId,
            });
        }
    });
    function computeCoeff(nodeId) {
        const node = nodes.get(nodeId);
        if (!node)
            return 1;
        if (node.parent && nodes.has(node.parent)) {
            return node.coeff * computeCoeff(node.parent);
        }
        return node.coeff;
    }
    let bestNode;
    let maxCoeff = -Infinity;
    nodes.forEach((node, nodeId) => {
        const totalCoeff = computeCoeff(nodeId);
        if (totalCoeff > maxCoeff || (totalCoeff === maxCoeff && nodeId !== node.parent)) {
            maxCoeff = totalCoeff;
            bestNode = nodeId;
        }
    });
    return bestNode;
}
